module.exports = __webpack_public_path__ + "static/img/08.0bde6a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/aquest/tutorial/08.svg
// module id = Gh29
// module chunks = 13